import { render, staticRenderFns } from "./DirectPlacementFilters.vue?vue&type=template&id=4aef9e89"
import script from "./DirectPlacementFilters.vue?vue&type=script&lang=js"
export * from "./DirectPlacementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports